// extracted by mini-css-extract-plugin
module.exports = {"fadeInSection":"fadeInSection_fadeInSection__i2hZb","isVisible":"fadeInSection_isVisible__yAVjv"};